import { faBell } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  JoonColorExpanded,
  ModalHeader,
  Typography,
  JoonUIColor,
  FamilyParentProfile,
  UserRole,
} from "@joonapp/web-shared"

import useScheduledMessageModalStore from "./useScheduledMessageModalStore"
import { useFamilyQuery } from "../../../networking/families/queries"
import { getFormattedTimeInTimezone } from "../../../util/time"
import useCurrentClient from "../hooks/useCurrentClient"

const ViewScheduledMessage = () => {
  const { onClose, message, clientDatetime } = useScheduledMessageModalStore()
  const { currentClientProfile } = useCurrentClient()
  const { data: family } = useFamilyQuery()
  const parentProfile = family?.profiles.find(
    (profile) => profile.role === UserRole.PARENT
  ) as FamilyParentProfile | undefined

  const formattedDate = clientDatetime?.format("MMM D")
  const clientTime = getFormattedTimeInTimezone(
    clientDatetime.format(),
    parentProfile?.user.timezone!
  )

  return (
    <>
      <ModalHeader
        title="Scheduled message"
        onClose={onClose}
        showBorderBottom
      />
      <div className="p-6 pt-4 gap-4 flex flex-col">
        <div className="flex flex-row p-4 gap-2 items-center border border-borderPrimary rounded-lg">
          <FontAwesomeIcon
            icon={faBell}
            fontSize={16}
            style={{
              //@ts-ignore
              "--fa-primary-color": JoonUIColor.icon.accent,
              "--fa-secondary-color": JoonColorExpanded.indigo300,
            }}
          />
          <Typography variant="body">
            Message sent on {formattedDate} at {clientTime} (in{" "}
            {currentClientProfile?.user.name}'s time)
          </Typography>
        </div>
        <div className="flex flex-col gap-1">
          <Typography variant="body">Message:</Typography>
          <div className="bg-bgXLightGray p-4 border border-borderPrimary rounded-lg">
            <Typography variant="body">{message}</Typography>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewScheduledMessage
